import { Usuario } from "./usuario";

export class LiberacaoAlcada {
  id: number;
  data: Date;
  tipoLiberacao: TipoLiberacaoAlcadaEnum;
  senhaLiberacao: string;
  usuarioId: number;
  usuario: Usuario;
  usuarioResponsavel: string;
}

export enum TipoLiberacaoAlcadaEnum {
  Observacao = 1,
  Desconto = 2
}
